import { observer } from 'mobx-react';
import selectEventDuration from '../actions/selectEventDuration';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import * as React from 'react';
import strings from 'owa-strings/owa-options-strings';
import createEventDurationDropdownOptions from '../utils/createEventDurationDropdownOptions';
import { getMeetingDuration } from '../selectors/getMeetingDuration';
import EventDurationOption from '../data/store/schema/EventDurationOption';

/**
 * Specifies the default meeting duration as dropdown options.
 * Valid dropdown options - 15, 25, 30, 45, 55, 60 minutes
 * Provides support for rendering a custom meeting duration in the dropdown
 */

let dropdownOptions: EventDurationOption[];

export default observer(function EventDurationSelection() {
    const defaultMeetingDuration = getMeetingDuration();

    const fetchDropdownOptions = (defaultMeetingDuration: number): EventDurationOption[] => {
        if (!dropdownOptions) {
            dropdownOptions = createEventDurationDropdownOptions(defaultMeetingDuration);
        }
        return dropdownOptions;
    };

    const onEventDurationChange = (option: IDropdownOption) => {
        selectEventDuration(option.key as number);
    };

    return (
        <div>
            <Dropdown
                selectedKey={defaultMeetingDuration}
                label={strings.options_default_event_length}
                options={fetchDropdownOptions(defaultMeetingDuration)}
                onChanged={onEventDurationChange}
            />
        </div>
    );
});
